import axios from "../../utils/axios";
import { isAzureFile } from "../contexts/HistoricAuditContext";
import type { ActionDTO } from "../types/actionDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const getByHistoricAuditId = (historicAuditId) =>
    axios.get<ActionDTO[]>(`${apiUrl}/historicaction/historicaudit/${historicAuditId}`)

const update = (historicActionId, historicActionDTO) => {
    const formData = new FormData();

    if (historicActionDTO.azureFile !== null && !isAzureFile(historicActionDTO.azureFile)) {
        formData.append("azureFile", historicActionDTO.azureFile);
    }
    formData.append("historicActionDTO", JSON.stringify(historicActionDTO));

    return axios.patch<ActionDTO>(`${apiUrl}/historicaction/${historicActionId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

const create = (historicActionDTO, historicAuditId) => {
    const formData = new FormData();

    if (historicActionDTO.azureFile !== null && !isAzureFile(historicActionDTO.azureFile)) {
        formData.append("azureFile", historicActionDTO.azureFile);
    }
    formData.append("historicActionDTO", JSON.stringify(historicActionDTO));
    formData.append("historicAuditId", historicAuditId.toString());

    // Deferred: controller returns the raw `Data.Models.HistoricAction` EF entity (saveResult.Value),
    // not the ActionDTO the [ProducesResponseType] claims. It opens a recursive/circular graph
    // (HistoricAction -> HistoricAudit -> Actions -> ..., plus HistoricIncident, ActionAzureFiles,
    // ActionComments). See summary.
    return axios.post(`${apiUrl}/historicaction/create`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

const archive = (historicActionId) =>
    axios.delete<void>(`${apiUrl}/historicaction/${historicActionId}`);

export const historicActionService = {
    getByHistoricAuditId,
    update,
    create,
    archive
}